'use client';

import { useRefreshUser, useUserWallets } from '@dynamic-labs/sdk-react-core';
import { useQuery } from '@tanstack/react-query';

import { GET_ASSETS_FOR_USER } from '@repo/api-core-toolkit';
import { useDatabaseQuery } from '@repo/utils';

import { Error } from '../../error';
import { Assets } from './assets';
import { LinkWallets } from './link-wallets';
import { Submit } from './submit';

interface BreakdownProps {
  isClaimActive: boolean;
}

export const Breakdown: React.FC<BreakdownProps> = ({ isClaimActive }) => {
  const refresh = useRefreshUser();
  const userWallets = useUserWallets();

  const { data: assetsForUser, isLoading } = useDatabaseQuery({
    queryKey: ['assets for user', userWallets.map((wallet) => wallet.address)],
    query: GET_ASSETS_FOR_USER as any,
    variables: { data: { userAddress: null } },
    field: 'getAssetsForUser',
    enabled: true,
    headers: {
      'api-key': process.env.NEXT_PUBLIC_GRAPHQL_API_KEY as string,
    },
  });

  useQuery({
    queryKey: [userWallets.map((wallet) => wallet.address)],
    queryFn: async () => {
      refresh();
      return null;
    },
  });

  if (!assetsForUser && !isLoading) {
    return <Error isClaimActive={isClaimActive} />;
  }

  const hasUnclaimedDood = assetsForUser?.totalAvailableToClaim > 0;

  return (
    <div className='p-4'>
      <LinkWallets />
      <Assets
        hasDood={hasUnclaimedDood}
        {...{ isClaimActive }}
      />
      <Submit
        hasDood={hasUnclaimedDood}
        {...{ isClaimActive }}
      />
    </div>
  );
};
